import { Box } from '@mui/material';
import React from 'react';

const Loading = ({ sx }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
    >
      <div className="load-next-transcript">
        <div className="three-bounce selected">
          <div className="one"></div>
          <div className="two"></div>
          <div className="three"></div>
        </div>
      </div>
    </Box>
  );
};

export default Loading;
